import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../App.css';
import 'rsuite/DatePicker/styles/index.css';
import Input from './Input';
import InputPhone from './InputPhone';
import { aplicarMascaraCpfCnpj } from '../utils/MaskUtils';
import { showNotification } from '../utils/NotificationUtils';
import Button from '@mui/material/Button';
import BackIcon from '@mui/icons-material/Reply';
import { request } from '../utils/ApiUtils';
import { getUserLogged } from '../utils/TokenUtils';
import CheckboxComConfirmacao from './ModalConfirmacao';

function ColaboradorForm() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [colaborador, setColaborador] = useState({ ativo: true })
    const [showInactiveModal, setShowInactiveModal] = useState(false)
    const [error, setError] = useState({})
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        loadColaborador();
    }, [id]);

    const loadColaborador = async () => {
        if (id) {
            request(`colaboradores/${id}`, {
                type: 'GET',
                callback: (data) => setColaborador(data),
                callbackError: (responseData, message) => showNotification(message || 'Ocorreu um erro inesperado, tente novamente ou contate o suporte.', 'error')
            })

        } else {
            setColaborador({ ativo: true });
        }
    }

    const salvarColaborador = async () => {
        colaborador.usuarioUltimaAlteracao = getUserLogged();
        setIsSaving(true);
        setColaborador({ ...colaborador });

        const method = colaborador.id ? "PUT" : "POST";
        const url = colaborador.id ? `colaboradores/${colaborador.id}` : "colaboradores";

        request(url, {
            type: method,
            body: JSON.stringify(colaborador),
            callback: (data) => {
                showNotification('Colaborador salvo', 'success');
                setColaborador(Object.assign({}, data));
                if (!id) navigate(`/colaboradores/cadastro/${data.id}`);
            },
            callbackError: (responseData, message) => {
                if (responseData?.errors) {
                    setError(responseData.errors);
                }

                if (responseData?.handledError) {
                    if (responseData?.errors && Object.keys(responseData.errors).length > 0) {
                        Object.entries(responseData.errors).forEach(([key, value]) => {

                            showNotification(value, 'error', 5000);
                        });
                    } else

                        if (responseData?.error) {
                            showNotification(responseData.error, 'error', 5000);
                        }
                } else {
                    showNotification('Não foi possível salvar o colaborador, revise os dados informados.', 'error');
                }
            },
            finally: () => {
                setIsSaving(false);
            }
        })
    };

    const handleInputChange = async (campo, valor) => {
        error[campo] = undefined;
        setError(error)

        setColaborador(prevColaborador => {
            const keys = campo.split("."); // Divide o caminho do campo (ex: ['endereco', 'rua'])
            const newColaborador = { ...prevColaborador }; // Clona o objeto principal

            // Percorre as chaves e recria os objetos internos
            keys.reduce((obj, key, index) => {
                if (index === keys.length - 1) {
                    obj[key] = valor; // Define o novo valor no campo correto
                } else {
                    obj[key] = { ...obj[key] }; // Clona o nível atual para manter a imutabilidade
                }
                return obj[key]; // Retorna o objeto aninhado para a próxima iteração
            }, newColaborador);

            newColaborador.porcentagemComissaoCaptador = !newColaborador.captador ? undefined : newColaborador.porcentagemComissaoCaptador;
            newColaborador.porcentagemComissaoFechador = !newColaborador.fechador ? undefined : newColaborador.porcentagemComissaoFechador;


            return newColaborador; // Retorna o novo estado atualizado
        });
    };


    return (
        <div className="form-container">

            <div id="notification-container" className='notification-container' style={{
                position: "fixed",
                display: "flex",
                justifyContent: "flex-end",
                flexWrap: "wrap-reverse",
                alignItems: "flex-end",
                top: "0", // Aqui muda pra aparecer no topo
                right: "30px",
                maxHeight: "100vh",
                zIndex: 9999
            }}></div>

            <div className="header-container-form">
                <h1 style={{ color: '#5E5E5E' }}>Colaborador</h1>
                <Button variant="text" onClick={() => navigate(`/colaboradores`)} startIcon={(<BackIcon style={{ fontSize: '2rem', fontWeight: 'bold', color: '#0057a3' }} />)} />
            </div>


            <div className='row'>
                <Input id="documento"
                    value={aplicarMascaraCpfCnpj(colaborador?.documento)}
                    parameters={{ error: error.documento, width: '20%', label: "Documento*", onChange: (value) => handleInputChange('documento', value) }} />

                <Input id="nome"
                    value={colaborador?.nome}
                    parameters={{ error: error.nome, width: '40%', label: "Nome*", onChange: (value) => handleInputChange('nome', value) }} />

                <Input id="setor"
                    value={colaborador?.setor}
                    parameters={{ error: error.setor, width: '30%', label: "Setor*", onChange: (value) => handleInputChange('setor', value) }} />

                <div className="checkbox-group">
                    <input type="checkbox" id="ativo" name="ativo" checked={colaborador.ativo} onClick={() => colaborador.ativo ? setShowInactiveModal(true) : handleInputChange('ativo', true)} />
                    <label htmlFor="ativo" className="checkbox-label">Ativo</label>
                </div>

            </div>

            <div className='row'>
                <div className="checkbox-group">
                    <input type="checkbox" id="recebeComissao" name="recebeComissao" checked={colaborador.recebeComissao} onClick={() => handleInputChange('recebeComissao', !colaborador?.recebeComissao)} />
                    <label htmlFor="recebeComissao" className="checkbox-label">Recebe Comissão</label>
                </div>
                
                <div className="checkbox-group">
                    <input type="checkbox" id="captador" name="captador" checked={colaborador.captador} onClick={() => handleInputChange('captador', !colaborador?.captador)} />
                    <label htmlFor="captador" className="checkbox-label">Captador</label>
                </div>

                <div className="checkbox-group">
                    <input type="checkbox" id="fechador" name="fechador" checked={colaborador.fechador} onClick={() => handleInputChange('fechador', !colaborador?.fechador)} />
                    <label htmlFor="fechador" className="checkbox-label">Fechador</label>
                </div>

                <Input id="porcentagemComissaoCaptador"
                    value={colaborador?.porcentagemComissaoCaptador}
                    parameters={{
                        width: '15%',
                        label: "Porcentagem Captador",
                        type: 'number',
                        min: 0, max: 90,
                        disabled: !colaborador?.captador,
                        step: 'any',
                        onChange: (value) => handleInputChange('porcentagemComissaoCaptador', value)
                    }} />

                <Input id="porcentagemComissaoFechador"
                    value={colaborador?.porcentagemComissaoFechador}
                    parameters={{
                        width: '15%',
                        label: "Porcentagem Fechador",
                        type: 'number',
                        min: 0, max: 90,
                        step: 'any',
                        disabled: !colaborador?.fechador,

                        onChange: (value) => handleInputChange('porcentagemComissaoFechador', value)
                    }} />
            </div>

            <div className='row'>

                {showInactiveModal && <CheckboxComConfirmacao parameters={{
                    message: "Atenção: Ao inativar o colaborador, ele não poderá mais ser selecionado na aba de Contratos. Tem certeza de que deseja continuar?",
                    confirm: () => {
                        setShowInactiveModal(false);
                        handleInputChange('ativo', false);
                    },
                    cancel: () => {
                        setShowInactiveModal(false);
                    }
                }}>
                </CheckboxComConfirmacao>}

            </div>

            {(
                <button onClick={() => salvarColaborador()} className="add-button">
                    Salvar colaborador
                </button>
            )}
        </div>
    );
}

export default ColaboradorForm;
